module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [(this.$route.params.id) ? _c('submenu') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blocks-list"
  }, [_c('draggable', {
    attrs: {
      "options": {
        handle: '.blocks-list__action--move'
      }
    },
    model: {
      value: (_vm.properties),
      callback: function($$v) {
        _vm.properties = $$v
      },
      expression: "properties"
    }
  }, [_c('transition-group', _vm._l((_vm.properties), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "blocks-list__item"
    }, [_c('div', {
      staticClass: "blocks-list__info"
    }, [_c('p', {
      staticClass: "blocks-list__title"
    }, [_vm._v("\n                          " + _vm._s(item.label) + "\n                        ")]), _vm._v(" "), _c('p', {
      staticClass: "blocks-list__type"
    }, [_vm._v(_vm._s(item.control))]), _vm._v(" "), _c('div', {
      staticClass: "blocks-list__actions"
    }, [_c('a', {
      staticClass: "blocks-list__action",
      attrs: {
        "href": "javascript: void(0)",
        "data-acc": "collapse-field"
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    }, [(!item.shown) ? _c('i', {
      staticClass: "icon icon--arrowd"
    }) : _c('i', {
      staticClass: "icon icon--arrowu"
    })]), _vm._v(" "), (!item.isDefault) ? _c('a', {
      staticClass: "blocks-list__action",
      attrs: {
        "href": "javascript: void(0)",
        "data-acc": "delete-field"
      },
      on: {
        "click": function($event) {
          return _vm.remove(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon--delete"
    })]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "blocks-list__action blocks-list__action--move",
      attrs: {
        "href": "javascript: void(0)"
      }
    }, [_c('i', {
      staticClass: "icon icon--move"
    })])])]), _vm._v(" "), (item.shown) ? _c('div', {
      staticClass: "blocks-list__control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.isDefault),
        expression: "item.isDefault"
      }],
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (item.isDefault)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "isDefault", $event.target.value)
        }
      }
    }), _vm._v(" "), (item.sharedGroups != null && item.sharedGroups.length) ? _c('span', [_vm._v("\n                          " + _vm._s(_vm.L.localize('Settings_Group_CustomFields_AlsoInGroup') + item.sharedGroups.join(', ')) + "\n                        ")]) : _vm._e(), _vm._v(" "), (!item.isDefault) ? _c('div', {
      staticClass: "form__input-container"
    }, [_c('fieldset', {
      staticClass: "form__field"
    }, [_c('label', {
      staticClass: "form__label"
    }, [_vm._v("\n                              " + _vm._s(_vm.L.localize("Settings_Group_CustomFields_Name")) + "\n                            ")]), _vm._v(" "), _c('v-autocomplete', {
      attrs: {
        "items": _vm.groupsSource,
        "auto-select-one-item": false,
        "get-label": _vm.getLabel,
        "component-item": _vm.template,
        "data-acc": "name"
      },
      on: {
        "item-clicked": function($event) {
          return _vm.mapProperties(item)
        },
        "change": function($event) {
          return _vm.lookup($event, item)
        },
        "update-items": _vm.updateItems
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (item.isDefault) ? _c('TextBox', {
      attrs: {
        "label": "Settings_Group_CustomFields_Name",
        "disabled": item.isDefault
      },
      on: {
        "input": function($event) {
          return _vm.lookup($event, item)
        }
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    }) : _vm._e(), _vm._v(" "), _c('TextBox', {
      attrs: {
        "label": "Settings_Group_CustomFields_Label"
      },
      model: {
        value: (item.label),
        callback: function($$v) {
          _vm.$set(item, "label", $$v)
        },
        expression: "item.label"
      }
    }), _vm._v(" "), _c('SelectList', {
      attrs: {
        "label": "Settings_Group_CustomFields_Type",
        "options": _vm.dataTypes
      },
      model: {
        value: (item.control),
        callback: function($$v) {
          _vm.$set(item, "control", $$v)
        },
        expression: "item.control"
      }
    }), _vm._v(" "), (_vm.isTextFieldType(item)) ? _c('TextBox', {
      attrs: {
        "label": "Settings_Group_CustomFields_Regex"
      },
      model: {
        value: (item.regexValidator),
        callback: function($$v) {
          _vm.$set(item, "regexValidator", $$v)
        },
        expression: "item.regexValidator"
      }
    }) : _vm._e(), _vm._v(" "), _c('CheckBox', {
      attrs: {
        "label": "Settings_Group_CustomFields_Required",
        "disabled": item.isDefault
      },
      model: {
        value: (item.required),
        callback: function($$v) {
          _vm.$set(item, "required", $$v)
        },
        expression: "item.required"
      }
    }), _vm._v(" "), _c('CheckBox', {
      attrs: {
        "label": "Settings_Group_CustomFields_DisplayInGrid"
      },
      model: {
        value: (item.displayInGrid),
        callback: function($$v) {
          _vm.$set(item, "displayInGrid", $$v)
        },
        expression: "item.displayInGrid"
      }
    }), _vm._v(" "), _c('CheckBox', {
      attrs: {
        "label": "Settings_Group_CustomFields_AdminOnly",
        "disabled": item.isDefault
      },
      model: {
        value: (item.adminOnly),
        callback: function($$v) {
          _vm.$set(item, "adminOnly", $$v)
        },
        expression: "item.adminOnly"
      }
    }), _vm._v(" "), (_vm.isTextFieldType(item)) ? _c('CheckBox', {
      attrs: {
        "label": "Settings_Group_CustomFields_IsAutomaticNumbering",
        "tooltip": "Settings_Group_CustomFields_IsAutomaticNumberingTooltip",
        "disabled": item.isDefault
      },
      model: {
        value: (item.isAutomaticNumbering),
        callback: function($$v) {
          _vm.$set(item, "isAutomaticNumbering", $$v)
        },
        expression: "item.isAutomaticNumbering"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showOptionsLabel(item)) ? _c('fieldset', {
      staticClass: "form__field"
    }, [_c('label', {
      staticClass: "form__label",
      attrs: {
        "for": "adminOnly"
      }
    }, [_vm._v("Options")]), _vm._v(" "), _c('ul', {
      staticClass: "light-crud-list"
    }, [_c('draggable', {
      attrs: {
        "options": {
          handle: '.light-crud-list__button-row--move'
        }
      },
      model: {
        value: (item.optionsLabels),
        callback: function($$v) {
          _vm.$set(item, "optionsLabels", $$v)
        },
        expression: "item.optionsLabels"
      }
    }, [_vm._l((item.optionsLabels), function(option, optionIndex) {
      return [_c('li', {
        staticClass: "light-crud-list__row"
      }, [_c('div', {
        staticClass: "light-crud-list__input-row"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.optionsLabels[optionIndex]),
          expression: "item.optionsLabels[optionIndex]"
        }],
        staticClass: "form__input",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (item.optionsLabels[optionIndex])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item.optionsLabels, optionIndex, $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "light-crud-list__button-row"
      }, [_c('a', {
        attrs: {
          "href": "javascript: void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.removeOptionRow(index, optionIndex)
          }
        }
      }, [_vm._v("\n                                            " + _vm._s(_vm.L.localize('Label_Delete')) + "\n                                              "), _c('i', {
        staticClass: "icon icon--minus"
      })]), _vm._v(" "), _c('a', {
        staticClass: "light-crud-list__button-row--move",
        attrs: {
          "href": "javascript: void(0)"
        }
      }, [_c('i', {
        staticClass: "icon icon--move"
      })])])])]
    })], 2), _vm._v(" "), _c('tfoot', [_c('li', [_c('div', {
      staticClass: "light-crud-list__add-row",
      attrs: {
        "colspan": "2"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript: void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.addOptionRow(index)
        }
      }
    }, [_vm._v("\n                                      " + _vm._s(_vm.L.localize('Label_Add')) + "\n                                      "), _c('i', {
      staticClass: "icon icon--plus"
    })])])])])], 1)]) : _vm._e()], 1) : _vm._e()])
  }), 0)], 1)], 1), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Label_SaveButton"
    },
    on: {
      "click": _vm.save
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Label_CancelButton",
      "withBorder": true
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'groups'
        })
      }
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Label_Add",
      "withBorder": true,
      "float": "right"
    },
    on: {
      "click": _vm.add
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e691bd1!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/groups/GroupCustomFields.vue
// module id = 743
// module chunks = 1